import React from 'react'
import { authRoles } from 'app/auth/authRoles'

const frontpadSyncRoutes = [
    {
        path: '/Settings/FrontpadSync',
        component: React.lazy(() => import('./FrontpadSyncPage')),
        auth: authRoles.admin,
        accessPageName: 'SETTINGS',
    },
]

export default frontpadSyncRoutes
